export const GET_ROOT_ACCOUNT = 'GET_ROOT_ACCOUNT'
export const GET_SUB_ROOT_ACCOUNT = 'GET_SUB_ROOT_ACCOUNT'
export const GET_SUBSCRIBERS = 'GET_SUBSCRIBERS'
export const GET_PAYMENT_TYPE = 'GET_PAYMENT_TYPE'
export const GET_PACKAGES = 'GET_PACKAGES'
export const GET_SERVICE_PAGE_INFO = 'GET_SERVICE_PAGE_INFO'
export const SET_SUBSCRIBER_DETAILS = 'SET_SUBSCRIBER_DETAILS'
export const SET_LINE_REMANING_BALANCES = 'SET_LINE_REMANING_BALANCES'
export const SET_LINE_INSTALLMENTS = 'SET_LINE_INSTALLMENTS'
export const SET_PREVIOUS_DEBTS = 'SET_PREVIOUS_DEBTS'
export const GET_BLACK_LIST_SUBSCRIBERS = 'GET_BLACK_LIST_SUBSCRIBERS'

